// extracted by mini-css-extract-plugin
export var btn = "H_mB w_sS w_sB d_bz d_bP d_bD d_dw";
export var full = "H_vN d_w d_H";
export var hoverStyle = "H_mF";
export var zoom = "H_mG";